import { AdminRole } from '@/store/AuthStore'

// Define what each role can access
export const ROLE_PERMISSIONS = {
  superAdmin: {
    canAccessCounsellors: true,
    canAccessWithdrawals: true,
    canAccessBroadcast: true,
    canAccessEvents: true,
    canAccessUsers: true,
    canAccessBlogs: true,
    canAccessCourseManagement: true,
    canAccessCollegeFees: true,
    canAccessPCSAT: true,
    canAccessTestSeries: true,
    canAccessGrandMockTest: true,
    canAccessEnquiries: true,
    canAccessProBuddies: true,
    canAccessReferrers: true,
    canAccessLeads: true,
    canAccessMyLeads: false,
    canAccessAbroadLeads: true,
    canAccessAdminAppointments: true,
    canAccessOptionForm: true,
    canAccessAnalytics: true,
    canAccessNeetPredictor: true,
    defaultRoute: '/',
  },
  blogger: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: true,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/blogs',
  },
  broadcastOfficer: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: true,
    canAccessEvents: true,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/broadcast',
  },
  payoutOfficer: {
    canAccessCounsellors: false,
    canAccessWithdrawals: true,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/withdrawls',
  },
  t3Onboarding: {
    canAccessCounsellors: true,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: true,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/',
  },
  COURSE: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: true,
    canAccessCollegeFees: false,
    canAccessPCSAT: true,
    canAccessTestSeries: true,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/course-management',
  },
  collegeAdmin: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: true,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: true,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/college-fees',
  },
  caller: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: true, // book-only access to the users list
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: true,
    canAccessAbroadLeads: true,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: true,
    defaultRoute: '/my-leads',
  },
  marketing: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: true,
    canAccessLeads: true,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: false,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/leads',
  },
  // Handles MHT-CET option form filling requests only: sees the registration
  // list, sets each one's status and assigns it to a counsellor.
  optionForm: {
    canAccessCounsellors: false,
    canAccessWithdrawals: false,
    canAccessBroadcast: false,
    canAccessEvents: false,
    canAccessUsers: false,
    canAccessBlogs: false,
    canAccessCourseManagement: false,
    canAccessCollegeFees: false,
    canAccessPCSAT: false,
    canAccessTestSeries: false,
    canAccessGrandMockTest: false,
    canAccessEnquiries: false,
    canAccessProBuddies: false,
    canAccessReferrers: false,
    canAccessLeads: false,
    canAccessMyLeads: false,
    canAccessAbroadLeads: false,
    canAccessAdminAppointments: false,
    canAccessOptionForm: true,
    canAccessAnalytics: false,
    canAccessNeetPredictor: false,
    defaultRoute: '/option-form-registrations',
  },
} as const

export function hasAccess(role: AdminRole | undefined, permission: keyof Omit<typeof ROLE_PERMISSIONS.superAdmin, 'defaultRoute'>): boolean {
  if (!role) return false
  return ROLE_PERMISSIONS[role][permission]
}

export function getDefaultRoute(role: AdminRole | undefined): string {
  if (!role) return '/'
  return ROLE_PERMISSIONS[role].defaultRoute
}

export function canAccessRoute(role: AdminRole | undefined, path: string): boolean {
  if (!role) return false

  const permissions = ROLE_PERMISSIONS[role]

  // Check based on route path
  if (path === '/' || path.startsWith('/counselor-profile')) {
    // PayoutOfficer can only access readonly profile
    if (role === 'payoutOfficer' && path === '/counselor-profile-readonly') {
      return true
    }
    return permissions.canAccessCounsellors
  }

  // Callers use this on the phone; super admins get it for spot checks.
  if (path === '/neet-predictor') {
    return permissions.canAccessNeetPredictor
  }

  if (path.startsWith('/withdrawls')) {
    return permissions.canAccessWithdrawals
  }

  if (path === '/profile') {
    return permissions.canAccessWithdrawals
  }

  if (path === '/broadcast') {
    return permissions.canAccessBroadcast
  }

  if (path.startsWith('/allevents') || path.startsWith('/addevent')) {
    return permissions.canAccessEvents
  }

  // Full user detail page is super-admin only; callers only get the list (to book).
  if (path.startsWith('/user-detail')) {
    return role === 'superAdmin'
  }

  if (path.startsWith('/users')) {
    return permissions.canAccessUsers
  }

  if (path === '/blogs') {
    return permissions.canAccessBlogs
  }

  if (path === '/course-management') {
    return permissions.canAccessCourseManagement
  }

  if (path === '/college-fees') {
    return permissions.canAccessCollegeFees
  }

  if (path === '/pcsat-registrations') {
    return permissions.canAccessPCSAT
  }

  if (path === '/test-series') {
    return permissions.canAccessTestSeries
  }

  if (path === '/grand-mock-tests') {
    return permissions.canAccessGrandMockTest
  }

  if (path === '/enquiries') {
    return permissions.canAccessEnquiries
  }

  if (path === '/probuddies' || path === '/probuddy-profile') {
    return permissions.canAccessProBuddies
  }

  if (path === '/referrers') {
    return permissions.canAccessReferrers
  }

  if (path.startsWith('/leads')) {
    return permissions.canAccessLeads
  }

  if (path === '/my-leads') {
    return permissions.canAccessMyLeads
  }

  // Study abroad enquiries from the website landing page: the callers work
  // them, super admins watch the volume.
  if (path === '/abroad-leads') {
    return permissions.canAccessAbroadLeads
  }

  if (path === '/admin-appointments') {
    return permissions.canAccessAdminAppointments
  }

  if (path === '/option-form-registrations') {
    return permissions.canAccessOptionForm
  }

  if (path === '/analytics') {
    return permissions.canAccessAnalytics
  }

  if (path === '/create-admin') {
    return role === 'superAdmin'
  }

  // Default deny
  return false
}
